// components/common/Stepper.jsx
import React from "react";

const Stepper = ({ steps, currentStep, completedStep, onStepClick }) => {
  return (
    <div className="d-flex justify-content-between align-items-center mb-4 position-relative">

      {/* LINE */}
      <div
        style={{
          position: "absolute",
          top: "18px",
          left: 0,
          right: 0,
          height: "2px",
          background: "#ddd",
          zIndex: 0,
        }}
      />

      {steps.map((step) => {
        const isCompleted = step <= completedStep;
        const isCurrent = step === currentStep;

        return (
          <div
            key={step}
            className="text-center"
            style={{ zIndex: 1, cursor: "pointer" }}
            onClick={() => onStepClick(step)}
          >
            {/* CIRCLE */}
            <div
              style={{
                width: 38,
                height: 38,
                borderRadius: "50%",
                background: isCompleted
                  ? "#4caf50" // completed
                  : isCurrent
                  ? "#2196f3" // current
                  : "#ccc", // pending
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto",
                fontWeight: "bold",
                transition: "0.3s",
              }}
            >
              {isCompleted ? "✓" : step}
            </div>

            {/* LABEL */}
            <div
              style={{
                fontSize: 12,
                marginTop: 6,
                fontWeight: isCurrent ? 1000 : 400,
              }}
            >
              {getStepLabel(step)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

// Labels
const getStepLabel = (step) => {
  const labels = {
    1: "Basic",
    2: "Schedule",
    3: "Modules",
    4: "Skills",
    5: "Review",
  };
  return labels[step] || `Step ${step}`;
};

export default Stepper;